var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("d2-container", [_c("wlc-breadcrumb"), _c("el-form", {
    attrs: {
      inline: true,
      model: _vm.searchForm,
      align: "right"
    }
  }, [_c("el-form-item", [_c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: function click($event) {
        _vm.form = {};
        _vm.dialogVisible = true;
      }
    }
  }, [_vm._v("新增")])], 1)], 1), _c("el-table", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.tableLoading,
      expression: "tableLoading"
    }],
    attrs: {
      data: _vm.tableData,
      border: ""
    }
  }, [_c("el-table-column", {
    attrs: {
      type: "index",
      label: "序号",
      width: "60"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "categoryName",
      label: "分类"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "排序",
      width: "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-input", {
          attrs: {
            placeholder: "序号",
            type: "number",
            size: "small"
          },
          model: {
            value: scope.row.weight,
            callback: function callback($$v) {
              _vm.$set(scope.row, "weight", $$v);
            },
            expression: "scope.row.weight"
          }
        }, [_c("el-button", {
          attrs: {
            slot: "append"
          },
          on: {
            click: function click($event) {
              return _vm.updateSort(scope.row);
            }
          },
          slot: "append"
        }, [_vm._v("保存")])], 1)];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "操作",
      width: "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-button", {
          attrs: {
            type: "text"
          },
          on: {
            click: function click($event) {
              return _vm.updateDialog(scope.row);
            }
          }
        }, [_vm._v("编辑")]), _c("el-button", {
          staticClass: "wlc-button-danger",
          attrs: {
            type: "text"
          },
          on: {
            click: function click($event) {
              return _vm.deleteItem(scope.row);
            }
          }
        }, [_vm._v("删除")])];
      }
    }])
  })], 1), _c("el-dialog", {
    attrs: {
      title: _vm.form.id ? "编辑" : "新增" + "".concat(_vm.$route.meta.title),
      width: "30%",
      visible: _vm.dialogVisible
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.dialogVisible = $event;
      }
    }
  }, [_c("el-form", {
    attrs: {
      model: _vm.form,
      "label-position": "right"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "分类"
    }
  }, [_c("el-select", {
    model: {
      value: _vm.form.categoryId,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "categoryId", $$v);
      },
      expression: "form.categoryId"
    }
  }, _vm._l(_vm.categoryList, function (item) {
    return _c("el-option", {
      key: item.id,
      attrs: {
        label: item.chName,
        value: item.id
      }
    });
  }), 1)], 1)], 1), _c("div", {
    staticClass: "dialog-footer",
    attrs: {
      slot: "footer"
    },
    slot: "footer"
  }, [_c("el-button", {
    attrs: {
      size: "small"
    },
    on: {
      click: function click($event) {
        _vm.dialogVisible = false;
      }
    }
  }, [_vm._v("取 消")]), _c("el-button", {
    attrs: {
      size: "small",
      type: "primary"
    },
    on: {
      click: _vm.save
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };